<!-- Header simplificado sin gradientes excesivos -->
<div class="bg-white shadow-sm border-b border-gray-200">
  <div class="w-full px-6 py-6">
    <!-- Título y botón nuevo plan -->
    <div class="flex justify-between items-center mb-6">
      <div class="flex items-center">
        <h1 class="text-2xl font-bold text-gray-900">
          <i class="fas fa-credit-card text-cyan-500 mr-2"></i>
          Gestión de Planes
        </h1>
        <button
          (click)="toggleHelp('dashboard')"
          class="ml-3 text-blue-600 hover:text-blue-800 transition-colors"
          title="Ayuda sobre el dashboard">
          <i class="fas fa-question-circle"></i>
        </button>
      </div>
    </div>

    <!-- Ayuda del Dashboard -->
    <div *ngIf="showHelp['dashboard']" class="mb-6 rounded-lg p-4 bg-blue-50 border border-blue-200">
      <div class="flex items-start">
        <i class="fas fa-info-circle text-blue-600 mt-1 mr-3"></i>
        <div class="flex-1">
          <h4 class="text-sm font-semibold mb-2 text-blue-800">{{ helpData['dashboard']?.title }}</h4>
          <div class="text-sm space-y-2 text-blue-800">
            <p><strong>Propósito:</strong> {{ helpData['dashboard']?.description }}</p>

            <div class="mt-3" *ngFor="let section of helpData['dashboard']?.sections">
              <p class="font-medium mb-1">{{ section.title }}:</p>
              <ul class="list-disc list-inside space-y-1 ml-2">
                <li *ngFor="let item of section.items">
                  <strong>{{ item.label }}:</strong> {{ item.description }}
                </li>
              </ul>
            </div>

            <div class="mt-3 p-2 bg-blue-100 rounded">
              <span class="text-lg mr-2">{{ helpData['dashboard']?.tip?.icon }}</span>
              <strong>{{ helpData['dashboard']?.tip?.title }}:</strong> {{ helpData['dashboard']?.tip?.text }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Métricas en tiempo real -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <!-- Total de Planes -->
      <div class="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow"
           title="Número total de planes creados en el sistema">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <div class="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-list-alt text-blue-600 text-xl"></i>
            </div>
          </div>
          <div class="ml-4">
            <p class="text-sm font-medium text-gray-600">Total de Planes</p>
            <p class="text-2xl font-bold text-gray-900">{{ metrics.totalPlanes }}</p>
            <p class="text-xs text-gray-500 mt-1">{{ metrics.nuevosEstesMes }} nuevos este mes</p>
          </div>
        </div>
      </div>

      <!-- Planes Activos -->
      <div class="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow"
           title="Planes que están disponibles para ser usados por los clientes">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <div class="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-check-circle text-green-600 text-xl"></i>
            </div>
          </div>
          <div class="ml-4">
            <p class="text-sm font-medium text-gray-600">Planes Activos</p>
            <p class="text-2xl font-bold text-gray-900">{{ metrics.planesActivos }}</p>
            <p class="text-xs text-gray-500 mt-1">{{ metrics.porcentajeActivos }}% del total</p>
          </div>
        </div>
      </div>

      <!-- Planes Inactivos -->
      <div class="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow"
           title="Planes que están deshabilitados y no se muestran a los clientes">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <div class="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-times-circle text-red-600 text-xl"></i>
            </div>
          </div>
          <div class="ml-4">
            <p class="text-sm font-medium text-gray-600">Planes Inactivos</p>
            <p class="text-2xl font-bold text-gray-900">{{ metrics.totalPlanes - metrics.planesActivos }}</p>
            <p class="text-xs text-gray-500 mt-1">No disponibles para clientes</p>
          </div>
        </div>
      </div>

      <!-- Próximos a Vencer - OCULTO POR SOLICITUD DEL USUARIO -->
      <!--
      <div class="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow"
           title="Planes que tienen fecha de finalización próxima y se desactivarán automáticamente">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <div class="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-exclamation-triangle text-yellow-600 text-xl"></i>
            </div>
          </div>
          <div class="ml-4">
            <p class="text-sm font-medium text-gray-600">Próximos a Vencer</p>
            <p class="text-2xl font-bold text-gray-900">{{ metrics.proximosVencer || 0 }}</p>
            <p class="text-xs text-gray-500 mt-1">Requieren atención</p>
          </div>
        </div>
      </div>
      -->
    </div>
  </div>
</div>

<!-- Filtros y controles -->
<div class="w-full px-6 py-6">
  <!-- Sección de filtros -->
  <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
    <div class="flex items-center justify-between mb-4">
      <div class="flex items-center">
        <h3 class="text-lg font-medium text-gray-900">Filtros y Búsqueda</h3>
        <button
          (click)="toggleHelp('filtros')"
          class="ml-3 text-green-600 hover:text-green-800 transition-colors"
          title="Ayuda sobre filtros">
          <i class="fas fa-question-circle"></i>
        </button>
      </div>
    </div>

    <!-- Ayuda de Filtros -->
    <div *ngIf="showHelp['filtros']" class="mb-4 rounded-lg p-4 bg-green-50 border border-green-200">
      <div class="flex items-start">
        <i class="fas fa-info-circle text-green-600 mt-1 mr-3"></i>
        <div class="flex-1">
          <h4 class="text-sm font-semibold mb-2 text-green-800">{{ helpData['filtros']?.title }}</h4>
          <div class="text-sm space-y-2 text-green-800">
            <p><strong>Propósito:</strong> {{ helpData['filtros']?.description }}</p>

            <div class="mt-3" *ngFor="let section of helpData['filtros']?.sections">
              <p class="font-medium mb-1">{{ section.title }}:</p>
              <ul class="list-disc list-inside space-y-1 ml-2">
                <li *ngFor="let item of section.items">
                  <strong>{{ item.label }}:</strong> {{ item.description }}
                </li>
              </ul>
            </div>

            <div class="mt-3 p-2 bg-green-100 rounded">
              <span class="text-lg mr-2">{{ helpData['filtros']?.tip?.icon }}</span>
              <strong>{{ helpData['filtros']?.tip?.title }}:</strong> {{ helpData['filtros']?.tip?.text }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
      <!-- Tipo de Producto -->
      <div class="relative">
        <label class="block text-sm font-medium text-gray-700 mb-2">
          <i class="fas fa-filter mr-1"></i>
          Tipo de Producto
        </label>
        <button
          type="button"
          (click)="toggleProductDropdown()"
          [disabled]="isLoadingProducts"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-colors bg-white text-left flex items-center justify-between hover:bg-gray-50"
          title="Filtrar por tipo de producto">
          <span *ngIf="isLoadingProducts" class="text-gray-400">
            <i class="fas fa-spinner fa-spin mr-2"></i>Cargando...
          </span>
          <span *ngIf="!isLoadingProducts" class="text-gray-900 font-medium">
            {{ getSelectedProductText() }}
          </span>
          <i class="fas fa-chevron-down text-gray-400" [class.rotate-180]="showProductDropdown"></i>
        </button>
        
        <!-- Dropdown de productos -->
        <div
          *ngIf="showProductDropdown"
          class="absolute z-50 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
          <div class="py-1">
            <button
              *ngFor="let product of productArray"
              type="button"
              (click)="selectProductType(product?.params?.code)"
              class="w-full px-4 py-2 text-left hover:bg-cyan-50 transition-colors flex items-center justify-between"
              [class.bg-cyan-100]="filters.filterProductType === product?.params?.code">
              <span class="font-medium">{{ product?.params?.code }}</span>
              <i *ngIf="filters.filterProductType === product?.params?.code" 
                 class="fas fa-check text-cyan-600"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Buscar -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">
          <i class="fas fa-search mr-1"></i>
          Buscar
        </label>
        <input
          type="text"
          placeholder="Nombre, código o descripción..."
          [(ngModel)]="filters.searchTerm"
          (input)="onSearch()"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-colors"
          title="Busca por nombre del plan, código único o descripción">
      </div>

      <!-- Estatus -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">
          <i class="fas fa-power-off mr-1"></i>
          Estado
        </label>
        <select
          [(ngModel)]="filters.filterEstado"
          (change)="onFilterChange()"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-colors"
          title="Filtra planes por su estado operativo">
          <option value="">Todos los estados</option>
          <option value="active">Activos (operativos)</option>
          <option value="inactive">Inactivos (suspendidos)</option>
        </select>
      </div>

      <!-- OCULTAR FILTRO VISIBILIDAD POR SOLICITUD DEL USUARIO
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">
          <i class="fas fa-eye mr-1"></i>
          Visibilidad
        </label>
        <select
          [(ngModel)]="filters.filterVisibilidad"
          (change)="onFilterChange()"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-colors"
          title="Filtra por el tipo de visibilidad del plan">
          <option value="">Todos los tipos</option>
          <option value="PUBLIC">Público (visible para todos)</option>
          <option value="PRIVATE">Privado (solo clientes específicos)</option>
        </select>
      </div>
      -->

      <!-- Prioridad -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">
          <i class="fas fa-sort-numeric-down mr-1"></i>
          Prioridad
        </label>
        <select
          [(ngModel)]="filters.filterPrioridad"
          (change)="onFilterChange()"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-colors"
          title="Filtra por nivel de prioridad del plan (mayor número = mayor prioridad)">
          <option value="">Todas las prioridades</option>
          <option value="0">Prioridad 0 (baja)</option>
          <option value="1">Prioridad 1</option>
          <option value="2">Prioridad 2</option>
          <option value="3">Prioridad 3 (alta)</option>
        </select>
      </div>
    </div>

    <!-- Controles adicionales -->
    <div class="flex justify-between items-center">
      <div class="flex items-center space-x-4">
        <button
          (click)="clearFilters()"
          class="text-sm text-blue-600 hover:text-blue-800 font-medium">
          Limpiar filtros
        </button>
      </div>

      <div class="flex items-center space-x-4">
        <span class="text-sm text-gray-600">Vista:</span>
        <div class="flex bg-gray-100 rounded-md p-1">
          <button
            (click)="viewMode = 'cards'"
            [class.bg-white]="viewMode === 'cards'"
            [class.shadow-sm]="viewMode === 'cards'"
            class="px-3 py-1 text-sm font-medium rounded transition-colors">
            <i class="fas fa-th mr-1"></i>
          </button>
          <button
            (click)="viewMode = 'list'"
            [class.bg-white]="viewMode === 'list'"
            [class.shadow-sm]="viewMode === 'list'"
            class="px-3 py-1 text-sm font-medium rounded transition-colors">
            <i class="fas fa-list mr-1"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Ordenamiento -->
  <div class="flex justify-between items-center mb-4">
    <div class="flex items-center space-x-4">
      <span class="text-sm text-gray-600">Ordenar por:</span>
      <button
        (click)="sortBy('name')"
        [class.text-blue-600]="sortField === 'name'"
        class="text-sm font-medium hover:text-blue-600 transition-colors">
        Nombre
        <i *ngIf="sortField === 'name'" class="fas ml-1"
           [class.fa-sort-up]="sortDirection === 'asc'"
           [class.fa-sort-down]="sortDirection === 'desc'"></i>
      </button>
      <button
        (click)="sortBy('date')"
        [class.text-blue-600]="sortField === 'date'"
        class="text-sm font-medium hover:text-blue-600 transition-colors">
        Fecha
        <i *ngIf="sortField === 'date'" class="fas ml-1"
           [class.fa-sort-up]="sortDirection === 'asc'"
           [class.fa-sort-down]="sortDirection === 'desc'"></i>
      </button>
      <button
        (click)="sortBy('priority')"
        [class.text-blue-600]="sortField === 'priority'"
        class="text-sm font-medium hover:text-blue-600 transition-colors">
        Prioridad
        <i *ngIf="sortField === 'priority'" class="fas ml-1"
           [class.fa-sort-up]="sortDirection === 'asc'"
           [class.fa-sort-down]="sortDirection === 'desc'"></i>
      </button>
      <button
        (click)="sortBy('status')"
        [class.text-blue-600]="sortField === 'status'"
        class="text-sm font-medium hover:text-blue-600 transition-colors">
        Estado
        <i *ngIf="sortField === 'status'" class="fas ml-1"
           [class.fa-sort-up]="sortDirection === 'asc'"
           [class.fa-sort-down]="sortDirection === 'desc'"></i>
      </button>
    </div>

    <p class="text-sm text-gray-600">Mostrando {{ filteredPlanes.length }} de {{ plans.length }} planes</p>
  </div>

  <!-- Loading State -->
  <div *ngIf="plansLoading" class="flex justify-center items-center py-12">
    <div class="text-center">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
      <p class="text-gray-600 mt-4">Cargando planes...</p>
    </div>
  </div>

  <!-- Vista de Cards (Principal) -->
  <div *ngIf="!plansLoading && viewMode === 'cards'">
    <!-- Empty State -->
    <div *ngIf="filteredPlanes.length === 0" class="text-center py-12">
      <i class="fas fa-search text-4xl text-gray-300 mb-4"></i>
      <h3 class="text-lg font-medium text-gray-900 mb-2">No se encontraron planes</h3>
      <p class="text-gray-600">Intenta ajustar los filtros o crear un nuevo plan</p>
      <button
        (click)="clearFilters()"
        class="mt-4 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors">
        Limpiar filtros
      </button>
    </div>

    <!-- Grid de Cards -->
    <div *ngIf="filteredPlanes.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div *ngFor="let plan of paginatedPlanes; trackBy: trackByPlanId"
           class="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">

        <!-- Header del plan -->
        <div class="flex justify-between items-start mb-4">
          <div class="flex-1">
            <h3 class="text-lg font-semibold text-blue-600 hover:text-blue-800 cursor-pointer"
                (click)="verPlan(plan)">
              {{ plan.name || plan.code }}
            </h3>
            <p class="text-sm text-gray-500">{{ plan.code }}</p>
          </div>
          <span
            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
            [ngClass]="getStatusBadgeClass(plan.status)">
            {{ plan.status ? 'Activo' : 'Inactivo' }}
          </span>
        </div>

        <!-- Información del plan -->
        <div class="space-y-3 mb-4">
          <!-- OCULTAR VISIBILIDAD POR SOLICITUD DEL USUARIO
          <div class="flex justify-between text-sm">
            <span class="text-gray-600">Visibilidad:</span>
            <span class="font-medium">{{ plan.visibility || 'Público' }}</span>
          </div>
          -->

          <div class="flex justify-between text-sm">
            <span class="text-gray-600">Prioridad:</span>
            <span class="font-medium">{{ plan.params?.priority || 0 }}</span>
          </div>

          <div class="flex justify-between text-sm">
            <span class="text-gray-600">Inicio:</span>
            <span class="font-medium">{{ formatDate(plan.params?.init_date || plan.date) }}</span>
          </div>

          <div class="flex justify-between text-sm">
            <span class="text-gray-600">Facturas:</span>
            <span class="font-medium text-blue-600">{{ plan.invoices || 0 }}</span>
          </div>
        </div>

        <!-- Rangos de montos -->
        <div *ngIf="plan.params?.min_amount_base || plan.params?.max_amount_base"
             class="bg-gray-50 rounded-lg p-3 mb-4">
          <div class="flex justify-between text-sm">
            <div>
              <span class="text-gray-600">Mín. Base</span>
              <p class="font-medium">${{ plan.params?.min_amount_base || 5.00 }}</p>
            </div>
            <div class="text-right">
              <span class="text-gray-600">Máx. Base</span>
              <p class="font-medium">${{ plan.params?.max_amount_base || 100.00 }}</p>
            </div>
          </div>
        </div>

        <!-- Términos de pago -->
        <div *ngIf="plan.payment_terms?.length" class="mb-4">
          <p class="text-sm text-gray-600 mb-2">Términos de pago:</p>
          <div class="text-sm text-gray-800">
            {{ getPaymentTermsText(plan.payment_terms) }}
          </div>
        </div>

        <!-- Acciones -->
        <div class="flex justify-between items-center pt-4 border-t border-gray-200">
          <div class="flex space-x-2">
            <button
              (click)="verPlan(plan)"
              class="text-blue-600 hover:text-blue-800 text-sm font-medium"
              title="Ver detalles completos del plan">
              <i class="fas fa-eye mr-1"></i>
              Ver
            </button>
            <button *ngIf="authService.hasPermission('config.planes.update')"
              (click)="editarPlan(plan)"
              class="text-orange-600 hover:text-orange-800 text-sm font-medium"
              title="Modificar configuración del plan">
              <i class="fas fa-edit mr-1"></i>
              Editar
            </button>
            <!-- BOTÓN DUPLICAR COMENTADO POR SOLICITUD DEL USUARIO
            <button
              (click)="duplicarPlan(plan)"
              class="text-purple-600 hover:text-purple-800 text-sm font-medium"
              title="Crear una copia de este plan">
              <i class="fas fa-copy mr-1"></i>
              Duplicar
            </button>
            -->
          </div>
          <button *ngIf="authService.hasPermission('config.planes.update')"
            (click)="toggleEstado(plan)"
            class="text-sm font-medium"
            [class.text-green-600]="plan.status"
            [class.hover:text-green-800]="plan.status"
            [class.text-red-600]="!plan.status"
            [class.hover:text-red-800]="!plan.status"
            [title]="plan.status ? 'Desactivar este plan' : 'Activar este plan'">
            <i class="fas mr-1"
               [class.fa-toggle-off]="!plan.status"
               [class.fa-toggle-on]="plan.status"></i>
            {{ plan.status ? 'Desactivar' : 'Activar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Paginación para cards -->
    <div *ngIf="filteredPlanes.length > 0" class="mt-8 flex justify-center">
      <div class="flex items-center space-x-2">
        <button
          (click)="previousPage()"
          [disabled]="currentPage === 1"
          class="px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
          <i class="fas fa-chevron-left mr-1"></i>
          Anterior
        </button>

        <div class="flex items-center space-x-1">
          <button
            *ngFor="let page of visiblePages"
            (click)="goToPage(page)"
            class="px-3 py-2 border rounded-lg text-sm font-medium transition-colors"
            [class.bg-blue-600]="page === currentPage"
            [class.text-white]="page === currentPage"
            [class.border-blue-600]="page === currentPage"
            [class.text-gray-700]="page !== currentPage"
            [class.border-gray-300]="page !== currentPage"
            [class.hover:bg-gray-50]="page !== currentPage">
            {{ page }}
          </button>
        </div>

        <button
          (click)="nextPage()"
          [disabled]="currentPage === totalPages"
          class="px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
          Siguiente
          <i class="fas fa-chevron-right ml-1"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Lista de Planes (Vista alternativa) -->
  <div *ngIf="!plansLoading && viewMode === 'list'" class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
    <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
      <div class="flex justify-between items-center">
        <div class="flex items-center">
          <h3 class="text-lg font-medium text-gray-900">Lista de Planes</h3>
          <button
            (click)="toggleHelp('acciones')"
            class="ml-3 text-purple-600 hover:text-purple-800 transition-colors"
            title="Ayuda sobre acciones disponibles">
            <i class="fas fa-question-circle"></i>
          </button>
        </div>
        <button *ngIf="authService.hasPermission('config.planes.create')"
          (click)="crearNuevoPlan()"
          class="flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg bg-blue-600 hover:bg-blue-700 transition-colors">
          <i class="fas fa-plus mr-2"></i>
          Nuevo Plan
        </button>
      </div>
    </div>

    <!-- Ayuda de Acciones -->
    <div *ngIf="showHelp['acciones']" class="mx-6 mt-4 mb-4 rounded-lg p-4 bg-purple-50 border border-purple-200">
      <div class="flex items-start">
        <i class="fas fa-info-circle text-purple-600 mt-1 mr-3"></i>
        <div class="flex-1">
          <h4 class="text-sm font-semibold mb-2 text-purple-800">{{ helpData['acciones']?.title }}</h4>
          <div class="text-sm space-y-2 text-purple-800">
            <p><strong>Propósito:</strong> {{ helpData['acciones']?.description }}</p>

            <div class="mt-3" *ngFor="let section of helpData['acciones']?.sections">
              <p class="font-medium mb-1">{{ section.title }}:</p>
              <ul class="list-disc list-inside space-y-1 ml-2">
                <li *ngFor="let item of section.items">
                  <i *ngIf="item.icon" class="{{ item.icon }} mr-1"></i>
                  <strong>{{ item.label }}:</strong> {{ item.description }}
                </li>
              </ul>
            </div>

            <div class="mt-3 p-2 bg-purple-100 rounded">
              <span class="text-lg mr-2">{{ helpData['acciones']?.tip?.icon }}</span>
              <strong>{{ helpData['acciones']?.tip?.title }}:</strong> {{ helpData['acciones']?.tip?.text }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="filteredPlanes.length === 0" class="text-center py-12">
      <i class="fas fa-search text-4xl text-gray-300 mb-4"></i>
      <h3 class="text-lg font-medium text-gray-900 mb-2">No se encontraron planes</h3>
      <p class="text-gray-600">Intenta ajustar los filtros o crear un nuevo plan</p>
    </div>

    <!-- Tabla de datos -->
    <div *ngIf="filteredPlanes.length > 0" class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <input type="checkbox" class="rounded border-gray-300">
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha de creación</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Usuario creador</th>
            <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Cuotas</th>
            <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Prioridad</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha de actualización</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Usuario actualizador</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acción</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let plan of paginatedPlanes; trackBy: trackByPlanId"
              class="hover:bg-gray-50 transition-colors">
            <td class="px-6 py-4 whitespace-nowrap">
              <input type="checkbox" class="rounded border-gray-300">
            </td>
            <!-- Nombre -->
            <td class="px-6 py-4 whitespace-nowrap">
              <div class="text-sm font-medium text-blue-600 hover:text-blue-800 cursor-pointer"
                   (click)="verPlan(plan)">
                {{ plan.name || plan.code }}
              </div>
              <div class="text-sm text-gray-500">{{ plan.code }}</div>
            </td>
            <!-- Fecha de creación -->
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ formatDate(plan?.date) }}
            </td>
            <!-- Usuario creador -->
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              {{ getCreatedByDisplayName(plan) }}
            </td>
            <!-- Cuotas -->
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
              {{ getQuotasText(plan) }}
            </td>
            <!-- Prioridad -->
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
              {{ getPriorityText(plan) }}
            </td>
            <!-- Fecha de actualización -->
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ plan.updated_by?.date ? formatDate(plan.updated_by.date) : '-' }}
            </td>
            <!-- Usuario actualizador -->
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              {{ getUpdatedByDisplayName(plan) }}
            </td>
            <!-- Acción -->
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
              <div class="flex items-center space-x-2">
                <!-- Botón papelera o placeholder para mantener spacing -->
                <div class="w-6 flex justify-center">
                  <button
                  *ngIf="(plan.invoices || 0) === 0 && authService.hasPermission('config.planes.delete')"
                  (click)="borrarPlan(plan)"
                  class="text-red-600 hover:text-red-900"
                  title="Borrar plan">
                  <i class="fas fa-trash"></i>
                  </button>
                </div>
                <button *ngIf="authService.hasPermission('config.planes.update')"
                  (click)="editarPlan(plan)"
                  class="text-orange-600 hover:text-orange-900"
                  title="Modificar">
                  <i class="fas fa-edit"></i>
                </button>
                <button *ngIf="authService.hasPermission('config.planes.update')"
                  (click)="toggleEstado(plan)"
                  class="hover:text-gray-900"
                  [class.text-green-600]="plan.status"
                  [class.text-red-600]="!plan.status"
                  [title]="plan.status ? 'Desactivar este plan' : 'Activar este plan'">
                  <i class="fas"
                     [class.fa-toggle-off]="!plan.status"
                     [class.fa-toggle-on]="plan.status"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación para lista -->
    <div *ngIf="filteredPlanes.length > 0" class="bg-white px-6 py-4 border-t border-gray-200">
      <div class="flex items-center justify-center">
        <span class="text-sm text-gray-700 mr-4">{{ currentPage }}</span>
        <div class="flex items-center space-x-2">
          <button
            (click)="previousPage()"
            [disabled]="currentPage === 1"
            class="px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            <i class="fas fa-chevron-left"></i>
          </button>

          <button
            (click)="nextPage()"
            [disabled]="currentPage === totalPages"
            class="px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

